import { useEffect, useState } from 'react';

import { fetchMe } from '../api/auth';
import { ApiError } from '../api/client';

export type BootstrapStatus = 'loading' | 'authenticated' | 'anonymous';

/** Resolves whether the httpOnly session cookie (if any) is still valid, once on app load. */
export function useAuthBootstrap(): BootstrapStatus {
  const [status, setStatus] = useState<BootstrapStatus>('loading');

  useEffect(() => {
    let cancelled = false;
    fetchMe()
      .then(() => {
        if (!cancelled) setStatus('authenticated');
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof ApiError && err.status === 401) setStatus('anonymous');
        else setStatus('anonymous');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return status;
}
